<template>
  <div class="major">
    <div class="tip">
      为了后期为您匹配更适合您的职业发展方向，技能提升服务或者相关最新资讯，您可以如实勾选需求以及擅长领域，为您职业发展助力。
    </div>
    <van-form @submit="onSubmit">
      <van-field
        style="border-radius: 12px 12px 0 0"
        v-model="name"
        name="姓名"
        label="姓名"
        placeholder="姓名"
        class="must"
        input-align="right"
        error-message-align="right"
        :rules="[{ required: true, message: '请填写姓名' }]"
        :class="{ activeText: name }"
        :border="false"
        @keyup="judgeDisabled()"
      />
      <van-field
        :value="birth"
        name="生日"
        label="生日"
        placeholder="请选择"
        class="must"
        is-link
        input-align="right"
        error-message-align="right"
        :rules="[{ required: true, message: '请选择' }]"
        @click="showPicker = true"
        :class="{ activeText: birth }"
        readonly
        :border="false"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-datetime-picker
          type="date"
          title="选择年月日"
          v-model="currentDate"
          :min-date="minDate"
          :max-date="maxDate"
          @cancel="showPicker = false"
          @confirm="onConfirm"
        />
      </van-popup>
      <van-field
        style="pointer-events: none"
        :value="age"
        name="年龄"
        label="年龄"
        class="must"
        input-align="right"
        error-message-align="right"
        :rules="[{ required: true, message: '请选择' }]"
        :class="{ activeText: age }"
        :border="false"
      />

      <van-field
        :value="sex"
        name="性别"
        label="性别"
        class="must"
        input-align="right"
        error-message-align="right"
        is-link
        :rules="[{ required: true, message: '请选择' }]"
        @click="showPicker2 = true"
        :class="{ activeText: sex }"
        :border="false"
        readonly
      />
      <van-popup v-model="showPicker2" position="bottom">
        <van-picker
          title="性别"
          v-model="sex"
          show-toolbar
          :columns="columns"
          @confirm="onConfirm2"
          @cancel="showPicker2 = false"
        />
      </van-popup>
      <van-field
        v-model="idNo"
        name="身份证号"
        label-width="120px"
        label="身份证号"
        placeholder="请输入"
        input-align="right"
        error-message-align="right"
        @keyup="judgeDisabled"
        :rules="[{ validator, message: '请输入正确身份证号' }]"
        :class="{ activeText: idNo }"
        :border="false"
      />
      <van-field
        :value="jobType"
        name="职业类型"
        label-width="120px"
        label="职业类型"
        placeholder="请选择"
        class="must"
        input-align="right"
        error-message-align="right"
        readonly
        is-link
        :rules="[{ required: true, message: '请选择' }]"
        @click="showPicker3 = true"
        :class="{ activeText: jobType }"
        :border="false"
      />
      <van-popup v-model="showPicker3" position="bottom">
        <van-picker
          title="职业类型"
          v-model="jobType"
          show-toolbar
          :columns="columns2"
          @confirm="onConfirm3"
          @cancel="showPicker3 = false"
        />
      </van-popup>
      <van-field
        v-if="catetypeData.length > 0"
        name="分类"
        label-width="120px"
        :label="jobType + '分类'"
        class="must specail"
        :value="classifyName"
        input-align="right"
        error-message-align="right"
        :border="false"
        :rules="[{ required: true, message: '请选择' }]"
      />
      <div class="catetype">
        <div
          v-for="(item, index) in catetypeData"
          :key="index"
          @click="
            item.active = !item.active;
            classifyName = catetypeData
              .filter((item) => item.active == true)
              .map((item) => item.name)
              .join(',');
            judgeDisabled();
          "
          :class="{ active: item.active }"
        >
          {{ item.name }}
        </div>
      </div>
      <!-- <van-popup v-model="showPicker4" position="bottom">
        <van-picker
          title="标题"
          v-model="major"
          show-toolbar
          :columns="catetypeData"
          @confirm="onConfirm4"
          @cancel="showPicker4 = false"
        />
      </van-popup> -->
      <van-field
        :value="scopeName"
        name="擅长范围"
        label-width="120px"
        label="擅长范围"
        placeholder="请选择"
        class="must custom clrBot"
        is-link
        input-align="right"
        error-message-align="right"
        :rules="[{ required: true, message: '请选择' }]"
        @click="showPicker5 = true"
        :class="{ activeText: scopeName }"
        autosize
        type="textarea"
        :border="false"
        readonly
        v-if="scopeData && scopeData.length > 0"
      />
      <van-popup
        v-model="showPicker5"
        position="bottom"
        @click-overlay="closeScope"
      >
        <p class="title">擅长范围</p>
        <div class="content">
          <div
            v-for="(item, index) in scopeData"
            :key="index"
            :class="{ active: item.active }"
            @click="item.active = !item.active"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="btns" @click="closeScope">确定</div>
      </van-popup>
      <van-field
        :value="directionName"
        name="擅长方向"
        label-width="120px"
        label="擅长方向"
        placeholder="请选择"
        class="must custom clrBot clrTop"
        input-align="right"
        error-message-align="right"
        is-link
        :rules="[{ required: true, message: '请选择' }]"
        @click="showPicker6 = true"
        :class="{ activeText: directionName }"
        type="textarea"
        autosize
        readonly
        :border="false"
        v-if="directionData && directionData.length > 0"
      />
      <van-popup
        v-model="showPicker6"
        position="bottom"
        @click-overlay="closeDirection"
      >
        <!-- <van-picker
          title="标题"
          v-model="directionName"
          show-toolbar
          :columns="directionData"
          @confirm="onConfirm6"
          @cancel="showPicker6 = false"
        /> -->
        <p class="title">擅长方向</p>
        <div class="content">
          <div
            v-for="(item, index) in directionData"
            :key="index"
            :class="{ active: item.active }"
            @click="item.active = !item.active"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="btns" @click="closeDirection">确定</div>
      </van-popup>
      <van-field
        :value="education"
        name="学历"
        label-width="120px"
        label="学历："
        placeholder="请选择"
        input-align="right"
        error-message-align="right"
        is-link
        @click="showPicker8 = true"
        :class="{ activeText: education }"
        :border="false"
        readonly
      />
      <van-popup v-model="showPicker8" position="bottom">
        <van-picker
          title="学历"
          v-model="education"
          show-toolbar
          :columns="columns8"
          @confirm="onConfirm8"
          @cancel="showPicker8 = false"
        />
      </van-popup>
      <van-field
        v-model="workYear"
        name="工作年限"
        label="工作年限（年）："
        label-width="170px"
        placeholder="请输入"
        maxlength="2"
        type="number"
        input-align="right"
        error-message-align="right"
        :class="{ activeText: workYear }"
        :border="false"
      />
      <van-field
        v-model="workUnit"
        name="以往工作单位："
        label="以往工作单位："
        label-width="130px"
        placeholder="请输入"
        input-align="right"
        maxlength="20"
        error-message-align="right"
        :class="{ activeText: workUnit }"
        :border="false"
      />
      <van-field
        :value="orgName"
        name="所属机构"
        label="所属机构："
        placeholder="请选择"
        is-link
        input-align="right"
        error-message-align="right"
        @click="showPicker7 = true"
        :class="{ activeText: orgName }"
        class="custom orgSpei"
        :border="false"
        type="textarea"
        autosize
        readonly
      />
      <van-popup v-model="showPicker7" position="bottom">
        <van-picker
          title="机构"
          v-model="orgName"
          show-toolbar
          :columns="columns7"
          @confirm="onConfirm7"
          @cancel="showPicker7 = false"
        />
      </van-popup>
      <van-field
        :value="street"
        name="机构地址"
        label="机构地址："
        placeholder="请选择"
        input-align="right"
        error-message-align="right"
        style="pointer-events: none"
        :class="{ activeText: street }"
        :border="false"
        type="textarea"
        class="customExtra org clrTop clrBot"
        autosize
      />
      <van-field
        name="uploader"
        label="资格证："
        class="extra-block"
        :border="false"
      >
        <template #input>
          <van-uploader
            v-model="qualificationProve"
            accept=".pdf, image/*"
            :max-size="5 * 1024 * 1024"
            @oversize="onOversize"
            :after-read="afterRead"
            :max-count="4"
            :upload-icon="plus"
            :before-delete="deleteQuali"
            @delete="curQuali"
          />
        </template>
      </van-field>
      <van-field
        name="uploader"
        label="其它技能证书："
        class="extra-block"
        label-width="130px"
        style="border-radius: 0px 0px 12px 12px"
        :border="false"
      >
        <template #input>
          <van-uploader
            v-model="otherProve"
            accept=".pdf, image/*"
            :max-size="5 * 1024 * 1024"
            @oversize="onOversize"
            :after-read="afterRead1"
            :max-count="4"
            :upload-icon="plus"
            :before-delete="deleteQuali1"
          />
        </template>
      </van-field>
      <div style="margin: 16px">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          :disabled="isDisabled"
          @click="jumpTo"
        >
          保存</van-button
        >
      </div>
      <div v-if="showLoading" class="loading">
        <van-loading color="#1989fa" />
      </div>
    </van-form>
  </div>
</template>

<script>
import {
  _getRehabilitationTrainerDict,
  _getOrganization,
  _upload,
  _add,
  _detail,
  _update,
  _getUser,
} from "../../../api/login";
import Cookies from "js-cookie";
import { decryptBy, encryptBy } from "@/assets/js/encryption";
export default {
  name: "",
  components: {},
  data() {
    return {
      showLoading: false,
      plus: require("../../../assets/images/login/plus.png"),
      home: require("../../../assets/images/login/enable-home.png"),
      showPicker: false, // 日历选择
      currentDate: new Date(),
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      showPicker2: false,
      columns: ["男", "女"],
      name: "", //姓名
      birth: "", // 出生日期
      sex: "", // 性别
      idNo: "", //身份证号
      age: "",
      jobType: "", // 康复师类型
      classifyName: "", //分类
      scopeName: "", // 擅长范围
      directionName: "", // 擅长方向
      workYear: "", //工作年限
      workUnit: "", // 以往工作单位
      orgName: "", //所属机构
      street: "", // 机构地址
      qualificationProve: [], // 资格证
      qualificationProveImgs: [], // 图片地址
      otherProve: [], // 其它技能证书
      otherProveImgs: [],
      isDisabled: true,
      columns2: [],
      showPicker3: false,
      totalData: [], // 保存所有的数据
      catetypeData: [], // 分类数据
      scopeData: [], // 范围数据
      directionData: [],
      showPicker4: false, //康复师分类
      showPicker5: false, //擅长范围
      showPicker6: false, // 擅长方向
      showPicker7: false,
      organizationData: [],
      columns7: [],
      education: "", // 学历
      columns8: [],
      showPicker8: false,
      orgId: "", // 机构id
      id: "",
    };
  },
  computed: {},
  methods: {
    judgeDisabled() {
      if (this.jobType !== "其他") {
        this.isDisabled = !(
          this.validator(this.idNo) &&
          this.name &&
          this.birth &&
          this.sex &&
          this.jobType &&
          this.classifyName &&
          this.scopeName &&
          this.directionName
        );
      } else {
        this.isDisabled = !(
          this.validator(this.idNo) &&
          this.name &&
          this.birth &&
          this.sex &&
          this.jobType &&
          this.classifyName
        );
      }
    },
    validator(value) {
      if (!value) return true;
      const reg =
        /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      return reg.test(value);
    },
    // 根据日期计算年龄
    toAge(birthday) {
      //根据日期算年龄
      if (birthday) {
        birthday = birthday.split("-");
        // 新建日期对象
        let date = new Date();
        // 今天日期，数组，同 birthday
        let today = [date.getFullYear(), date.getMonth() + 1, date.getDate()];
        // 分别计算年月日差值
        let age = today.map((val, index) => {
          return val - birthday[index];
        });
        // 当天数为负数时，月减 1，天数加上月总天数
        if (age[2] < 0) {
          // 简单获取上个月总天数的方法，不会错
          let lastMonth = new Date(today[0], today[1], 0);
          age[1]--;
          age[2] += lastMonth.getDate();
        }
        // 当月数为负数时，年减 1，月数加上 12
        if (age[1] < 0) {
          age[0]--;
          age[1] += 12;
        }
        console.log(age[0] + "岁" + age[1] + "月" + age[2] + "天");
        return age[0];
      }
    },
    onConfirm() {
      let date = this.currentDate;
      let year = date.getFullYear(); //年
      let month = date.getMonth() + 1; //月
      let strDate = date.getDate();
      this.birth = `${year}-${month}-${strDate}`;
      this.age = this.toAge(this.birth);
      this.showPicker = false;
      this.judgeDisabled();
    },
    onConfirm2(value) {
      this.sex = value;
      this.showPicker2 = false;
      this.judgeDisabled();
    },
    // 康复师选择
    onConfirm3(value) {
      this.jobType = value;
      this.classifyName = "";
      this.scopeName = "";
      this.directionName = "";
      this.catetypeData = [];
      this.scopeData = [];
      this.directionData = [];
      console.log(this.jobType);
      this.showPicker3 = false;
      let curData = this.totalData.filter((item) => {
        return item.name === value;
      });
      // 1.分类
      curData[0].children.forEach((item) => {
        if (item.code === "_type") {
          this.catetypeData = item.children.map((item) => {
            return { name: item.name, active: false };
          });
        }
      });
      // 2.范围
      curData[0].children.forEach((item) => {
        if (item.code === "professional_scope") {
          this.scopeData = item.children.map((item) => {
            return { name: item.name, active: false };
          });
        }
      });
      //3.方向
      curData[0].children.forEach((item) => {
        if (item.code === "professional_direction") {
          this.directionData = item.children.map((item) => {
            return { name: item.name, active: false };
          });
        }
      });
      console.log(curData);
      this.judgeDisabled();
    },
    // onConfirm4(value) {
    //   this.classifyName = value;
    //   this.showPicker4 = false;
    // },
    onConfirm5(value) {
      this.scopeName = value;
      this.showPicker5 = false;
    },
    onConfirm6(value) {
      this.directionName = value;
      this.showPicker6 = false;
    },
    onConfirm7(value) {
      this.orgName = value;
      this.organizationData.forEach((item) => {
        if (item.name === value) {
          this.orgId = item.id;
          this.street = `${item.province}${item.city}${item.district}${item.street}`;
        }
      });
      this.showPicker7 = false;
    },
    onConfirm8(value) {
      this.showPicker8 = false;
      this.education = value;
    },
    async getRehabilitationTrainerDict() {
      const res = await _getRehabilitationTrainerDict(
        "rehabilitationTrainerType"
      );
      if (res && res.code === 200) {
        this.totalData = res.data;
        this.columns2 = this.totalData.map((item) => item.name);
      }
    },
    async getEducationDict() {
      const res = await _getRehabilitationTrainerDict("education");
      if (res && res.code === 200) {
        let data = res.data;
        this.columns8 = data.map((item) => item.name);
      }
    },
    async getOrganization() {
      let params = {
        // asc: false,
        currentPage: 1,
        // orderByField: "id",
        pageSize: 100,
        // queryData: { orgType: [3, 4] },
      };

      const res = await _getOrganization(params);
      if (res && res.code === 200) {
        this.organizationData = res.data.records;
        this.columns7 = this.organizationData.map((item) => item.name);
      }
    },
    closeScope() {
      this.showPicker5 = false;
      this.scopeName = this.scopeData
        .filter((item) => item.active == true)
        .map((item) => item.name)
        .join(",");
      this.judgeDisabled();
    },
    closeDirection() {
      this.showPicker6 = false;
      this.directionName = this.directionData
        .filter((item) => item.active == true)
        .map((item) => item.name)
        .join(",");
      this.judgeDisabled();
    },
    // beforeRead(file) {
    //   if (file.type !== "image/jpeg") {
    //     Toast("请上传 jpg 格式图片");
    //     return false;
    //   }
    //   return true;
    // },
    onOversize(file) {
      console.log(file);
      Toast("文件大小不能超过 5MB");
    },
    onSubmit(values) {
      console.log("submit", values);
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log("111", file);
      let formData = new FormData();
      formData.append("file", file.file);
      _upload(formData).then((res) => {
        if (res && res.code == 200) {
          let domain = process.env.VUE_APP__BASE_UPLOAD_URL;
          this.qualificationProveImgs.push(`${domain}${res.data}`);
          // console.log(this.qualificationProve);
        }
      });
    },
    afterRead1(file) {
      // 此时可以自行将文件上传至服务器
      // console.log("111", file);
      let formData = new FormData();
      formData.append("file", file.file);
      _upload(formData).then((res) => {
        if (res && res.code == 200) {
          let domain = process.env.VUE_APP__BASE_UPLOAD_URL;
          this.otherProveImgs.push(`${domain}${res.data}`);
          // console.log(this.otherProveImgs);
        }
      });
    },
    deleteQuali(file, detail) {
      // console.log(this.qualificationProve);
      let vm = this;
      return new Promise((resolve, reject) => {
        // 将压缩后的图片删除
        vm.qualificationProveImgs.splice(detail.index, 1);
        resolve();
      });
    },
    curQuali() {
      console.log(this.qualificationProve);
      console.log(this.qualificationProveImgs);
    },
    deleteQuali1(file, detail) {
      // console.log(this.qualificationProve);
      let vm = this;
      return new Promise((resolve, reject) => {
        // 将压缩后的图片删除
        vm.otherProveImgs.splice(detail.index, 1);
        resolve();
      });
    },
    updateUser() {
      _getUser({
        authentication: Cookies.get("token"),
      }).then((res) => {
        if (res && res.code == 200) {
          this.$store.commit("USER_INFO", res.data);
          localStorage.setItem("userInfo", encryptBy(JSON.stringify(res.data)));
          this.$router.replace("/");
        } else {
          this.$toast(res.message);
        }
      });
    },
    jumpTo() {
      let info = localStorage.getItem("userInfo");
      let user = JSON.parse(decryptBy(info));
      let phone = user.mobilePhone;
      let params = {
        id: this.id,
        // 机构id
        orgId: this.orgId,
        applyPlatform: 2,
        phone,
        name: this.name,
        birth: this.birth,
        sex: this.sex === "男" ? 0 : 1,
        idNo: this.idNo,
        jobType: this.totalData.filter((item) => item.name == this.jobType)[0]
          .code,
        classifyName: this.catetypeData
          .filter((item) => item.active == true)
          .map((item) => item.name)
          .join(","),
        scopeName: this.scopeName,
        directionName: this.directionName,
        education: this.education,
        workYear: this.workYear,
        workUnit: this.workUnit,
        orgName: this.orgName,
        street: this.street,
        qualificationProve: this.qualificationProveImgs.join(","),
        otherProve: this.otherProveImgs.join(","),
      };
      this.showLoading = true;
      if (!this.id) {
        _add(params)
          .then((res) => {
            if (res && res.code === 200) {
              this.updateUser();
            } else {
              this.$toast(res.message);
            }
            this.showLoading = false;
          })
          .catch((err) => {
            this.showLoading = false;
          });
      } else {
        _update(params)
          .then((res) => {
            if (res && res.code === 200) {
              this.updateUser();
            } else {
              this.$toast(res.message);
            }
            this.showLoading = false;
          })
          .catch((err) => {
            this.showLoading = false;
          });
      }
    },
    getDetail() {
      _detail()
        .then((res) => {
          if (res && res.code === 200) {
            let data = res.data;
            if (data.sex == 0) {
              data.sex = "男";
            } else {
              data.sex = "女";
            }

            let {
              id,
              name,
              birth,
              sex,
              idNo,
              jobType,
              classifyName,
              scopeName,
              directionName,
              education,
              workYear,
              workUnit,
              orgName,
              street,
              qualificationProve,
              otherProve,
            } = data;
            this.id = id;
            this.name = name;
            this.birth = birth;
            this.age = this.toAge(this.birth);
            this.sex = sex;
            this.idNo = idNo;
            this.education = education;
            this.workYear = workYear;
            this.workUnit = workUnit;
            this.orgName = orgName;
            this.organizationData.forEach((item) => {
              if (item.name === orgName) {
                this.orgId = item.id;
              }
            });
            this.street = street;
            if (qualificationProve) {
              this.qualificationProve = qualificationProve
                .split(",")
                .map((item) => {
                  return { url: item };
                });
              this.qualificationProveImgs = qualificationProve.split(",");
            } else {
              this.qualificationProve = [];
              this.qualificationProveImgs = [];
            }
            if (otherProve) {
              this.otherProve = otherProve.split(",").map((item) => {
                return { url: item };
              });
              this.otherProveImgs = otherProve.split(",");
            } else {
              this.otherProve = [];
              this.otherProveImgs = [];
            }
            console.log(this.totalData, jobType);
            this.$nextTick(() => {
              this.jobType = this.totalData.filter(
                (item) => item.code == jobType
              )[0].name;
              console.log("111", this.jobType);
              let curData = this.totalData.filter((item) => {
                return item.name == this.jobType;
              });
              this.classifyName = classifyName;
              // 1.分类
              curData[0].children.forEach((item) => {
                if (item.code === "_type") {
                  this.catetypeData = item.children.map((item) => {
                    return {
                      name: item.name,
                      active: classifyName.split(",").indexOf(item.name) > -1,
                    };
                  });
                }
              });
              this.scopeName = scopeName;
              // 2.范围
              curData[0].children.forEach((item) => {
                if (item.code === "professional_scope") {
                  this.scopeData = item.children.map((item) => {
                    return {
                      name: item.name,
                      active: scopeName.split(",").indexOf(item.name) > -1,
                    };
                  });
                }
              });
              this.directionName = directionName;
              //3.方向
              curData[0].children.forEach((item) => {
                if (item.code === "professional_direction") {
                  this.directionData = item.children.map((item) => {
                    return {
                      name: item.name,
                      active: directionName.split(",").indexOf(item.name) > -1,
                    };
                  });
                }
              });
              this.judgeDisabled();
            });
          } else {
            this.$toast(res.message);
          }
          this.showLoading = false;
        })
        .catch((err) => {
          this.showLoading = false;
        });
    },
  },
  created() {
    // this.getRehabilitationTrainerDict();
    // this.getOrganization();
    // this.getEducationDict();
    this.showLoading = true;
    Promise.all([
      this.getRehabilitationTrainerDict(),
      this.getOrganization(),
      this.getEducationDict(),
    ])
      .then((values) => {
        let { isParent } = this.$route.query;
        if (isParent && isParent == "2") {
          this.getDetail();
        } else {
          this.showLoading = false;
        }
      })
      .finally(() => {
        this.showLoading = false;
      });
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
div.major {
  padding-bottom: 20px;
  div.tip {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2e4344;
    line-height: 17px;
    margin-bottom: 12px;
  }
  /deep/.van-field__label {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #2e4344;
  }
  /deep/ .must > .van-field__label:before {
    content: "*";
    color: #ee3721;
    margin-right: 4px;
  }
  /deep/ .van-field__control {
    text-align: right;
  }
  /deep/ .normal .van-field__control {
    text-align: left;
  }
  /deep/ .van-field__control::placeholder {
    color: #cccccc !important;
  }
  /deep/ .normal .van-field__label {
    color: #00aadf;
  }
  /deep/ textarea {
    box-sizing: border-box;
    padding: 8px 12px;
    background: #f3f6f7;
    border-radius: 4px;
    width: 236px;
    // height: 95px;
  }
  /deep/ .custom textarea {
    background: transparent;
    padding: 0;
    width: 160px;
  }
  /deep/ .customExtra textarea {
    background: transparent;
    padding: 0;
    width: 184px;
  }
  /deep/ .van-field__word-limit {
    position: relative;
    top: -26px;
    left: -26px;
    .van-field__word-num {
      color: #00aadf;
    }
  }
  /deep/.extra-block {
    display: block;
    .van-field__label {
      margin-bottom: 14px;
    }
  }
  /deep/.van-button--info {
    border: none;
    background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
  }
  /deep/.van-button--disabled {
    background: #949c9d;
    border: none;
  }
  /deep/ .van-icon__image {
    position: relative;
    top: 2px;
  }
  .catetype {
    display: flex;
    flex-wrap: wrap;
    background: #fff;
    > div {
      margin-left: 10px;
      margin-right: 10px;
      width: 143px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: rgba(0, 170, 223, 0.1);
      border-radius: 4px;
      margin-bottom: 10px;
      color: #00aadf;
    }
    div.active {
      background: #00aadf;
      color: #fff;
    }
  }
  p.title {
    margin-top: 35px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #2e4344;
    text-align: center;
  }
  div.content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    margin-left: 10px;
    > div {
      margin-left: 10px;
      margin-bottom: 12px;
      background: rgba(250, 125, 0, 0.1);
      border-radius: 20px;
      padding: 10px 12px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fa7d00;
    }
    div.active {
      background: #de8e43;
      color: #fff;
    }
  }
  div.btns {
    width: 335px;
    height: 44px;
    background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
    border-radius: 22px;
    margin: 45px auto;
    line-height: 44px;
    text-align: center;
    color: #ffffff;
  }
  .activeText {
    /deep/ .van-field__control {
      color: #00aadf;
    }
  }
  /deep/ .specail {
    .van-field__body {
      input {
        opacity: 0;
      }
    }
  }
  .clrTop {
    padding-top: 0;
  }
  .clrBot {
    padding-bottom: 0;
  }
  /deep/ .van-cell__right-icon {
    margin-right: 0;
  }
  .org {
    /deep/ .van-field__body .van-field__control {
      color: #949c9d;
    }
  }
  .orgSpei {
    /deep/.van-field__body {
      background: #f3f6f7;
    }
    /deep/ .van-cell__right-icon {
      height: auto;
      margin-left: 0;
      background: #f3f6f7;
    }
  }
  .loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(255, 255, 255, 0.8);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
